<template lang="html">
  <div class="min-vh-100 bg-white" id="customizer-page">
    <loading-bg-component v-if="isLoading"></loading-bg-component>
    <!-- Header -->
    <!-- <header class="border-bottom bg-white sticky-top shadow-sm" style="z-index: 1020;">
      <div class="container px-3 px-sm-4 py-3 py-sm-4 position-relative">
        <div class="d-flex align-items-center justify-content-between flex-wrap">
          <img src="public/images/pages/customizer/xv-shopping-logo.png" alt="XV Shopping" class="personalizador-logo flex-shrink-0">

          <div class="d-flex align-items-center flex-wrap justify-content-end" style="gap: 0.5rem;">
            <button
              type="button"
              class="btn btn-secondary btn-sm d-flex align-items-center"
              @click="showTrackModal = true"
            >
              <i class="fa-solid fa-box"></i>
              <span class="d-none d-sm-inline ml-1">Revisar pedido</span>
            </button>

            <button
              type="button"
              class="btn btn-primary btn-sm d-flex align-items-center"
              @click="showRecoverModal = true"
            >
              <i class="fa-solid fa-heart"></i>
              <span class="d-none d-sm-inline ml-1">Recuperar</span>
            </button>

            <button
              type="button"
              class="btn btn-success btn-sm d-flex align-items-center"
              @click="shareOnWhatsApp"
            >
              <i class="fa-brands fa-whatsapp"></i>
              <span class="d-none d-sm-inline ml-1">Compartir</span>
            </button>
          </div>
        </div>
      </div>
    </header> -->

    <main class="container px-3 px-sm-4 py-3 py-sm-4">
      <!-- Summary bar -->
      <div class="personalizador-summary mb-4 p-3 mx-auto position-relative" style="max-width: 80rem;">
        <div class="d-flex align-items-center flex-wrap position-relative">
          <!-- <div class="flex-shrink-0 rounded overflow-hidden bg-white personalizador-thumb mr-3 mb-2 mb-md-0">
            <img src="" class="img-fluid p-1 personalizador-thumb-img">
          </div> -->

          <div class="d-flex flex-wrap align-items-center flex-grow-1 small col-label" style="gap: 0.5rem;">
            <span class="font-weight-bold text-dark">Tu personalización:</span>
          </div>

          <div class="d-flex flex-wrap align-items-center flex-grow-1 small col-results">
            <span class="text-muted font-italic" v-if="!summaryInfo.model">
              Comienza seleccionando un estilo...
            </span>

            <span v-if="summaryInfo.model" class="badge badge-pill bg-white border border-primary text-dark px-3 py-2">
              <span class="txt-c-1 font-weight-medium">Estilo:</span>
              {{ summaryInfo.model.name }}
            </span>

            <span v-if="summaryInfo.occasion" class="badge badge-pill bg-white border border-primary text-dark px-3 py-2">
              <span class="txt-c-1 font-weight-medium">Ocasión:</span>
              {{ summaryInfo.occasion.name }}
            </span>

            <span v-if="summaryInfo.embroidery" class="badge badge-pill bg-white border border-primary text-dark px-3 py-2">
              <span class="txt-c-1 font-weight-medium">Bordado:</span>
              {{ summaryInfo.embroidery.name }}
            </span>

            <span v-if="summaryInfo.backgroundColor" class="badge badge-pill bg-white border border-primary text-dark px-3 py-2 d-inline-flex align-items-center" style="gap: 0.35rem;">
              <span class="txt-c-1 font-weight-medium">Fondo:</span>
              <span
                class="rounded-circle border d-inline-block"
                style="width: 1rem; height: 1rem;"
                :style="{ backgroundColor: summaryInfo.backgroundColor.color_code }"
              ></span>
              {{ summaryInfo.backgroundColor.name }}
            </span>

            <span v-if="summaryInfo.ribbonColor" class="badge badge-pill bg-white border border-primary text-dark px-3 py-2 d-inline-flex align-items-center" style="gap: 0.35rem;">
              <span class="txt-c-1 font-weight-medium">{{ colorOptionName1 }}:</span>
              <span
                class="rounded-circle border d-inline-block"
                style="width: 1rem; height: 1rem;"
                :style="{ backgroundColor: summaryInfo.ribbonColor.color_code }"
              ></span>
              {{ summaryInfo.ribbonColor.name }}
            </span>

            <span v-if="summaryInfo.embroideryColor" class="badge badge-pill badge-light border border-primary text-dark px-3 py-2 d-inline-flex align-items-center" style="gap: 0.35rem;">
              <span class="txt-c-1 font-weight-medium">Color bordado:</span>
              <span
                class="rounded-circle border d-inline-block"
                style="width: 1rem; height: 1rem;"
                :style="{ backgroundColor: summaryInfo.embroideryColor.color_code }"
              ></span>
              {{ summaryInfo.embroideryColor.name }}
            </span>

            <span v-if="summaryInfo.extraColor" class="badge badge-pill bg-white border border-primary text-dark px-3 py-2 d-inline-flex align-items-center" style="gap: 0.35rem;">
              <span class="txt-c-1 font-weight-medium">{{ colorOptionName4 }}:</span>
              <span
                class="rounded-circle border d-inline-block"
                style="width: 1rem; height: 1rem;"
                :style="{ backgroundColor: summaryInfo.extraColor.color_code }"
              ></span>
              {{ summaryInfo.extraColor.name }}
            </span>

            <span v-if="summaryInfo.accessory" class="badge badge-pill bg-white border border-primary text-dark px-3 py-2">
              <span class="txt-c-1 font-weight-medium">Accesorio:</span>
              {{ summaryInfo.accessory.name }}
            </span>

            <!-- <span class="badge badge-pill badge-light border border-primary text-dark px-3 py-2">
              <span class="text-primary font-weight-medium">Texto:</span>
              "Hola mundo"
            </span> -->

            <!-- <span class="badge badge-pill badge-success px-3 py-2">
              <i class="fa-solid fa-check mr-1"></i> Aplicado a todo el set
            </span> -->
          </div>

          <!-- <button class="btn btn-favorite" type="button" @click="showSaveModal = true"><i class="fa-solid fa-heart text-primary"></i></button> -->
        </div>
      </div>
<!-- <strong>step:</strong>{{ step }}<br>
<strong>currentPieceForm:</strong>{{ currentPieceForm }}<br>
<strong>summaryInfo:</strong>{{ summaryInfo }}<br>
<strong>customizerForm:</strong>{{ customizerForm }}<br>  -->
      <div class="row">
        <!-- Columna formulario -->
        <div class="col-lg-5 mb-4">
          <!-- 1. Piezas a diseñar -->
          <div class="card card-wrapper mb-3">
            <button class="btn btn-step" @click="expandedSections.piece = !expandedSections.piece">
              <div class="col col-step-number"><span class="flex-center-xy">1</span></div>
              <div class="col col-text">
                <h6 class="box-title mb-1">Piezas a diseñar</h6>
                <p class="p-simple">Este estilo incluye los siguientes productos</p>
              </div>
              <div class="col col-check"><i class="fa-solid fa-circle-check" v-if="summaryInfo.piece"></i></div>

              <div class="col col-chevron">
                <i class="fa-solid fa-chevron-down text-muted icon" :class="{ 'active': expandedSections.piece }"></i>
              </div>
            </button>

            <div class="card-body pt-0 box-pieces-options" v-if="expandedSections.piece">
              <div class="box-pieces-container">
                <button class="t-150 btn-piece-option" :class="{ 'active': currentPieceForm.piece === piece.value }" v-for="(piece, pInx) in pieceOptions" :key="'pInx-'+pInx" @click="selectPiece(piece)">
                  <i class="fa-solid fa-circle-check completed-icon"  v-if="Object.keys(customizerForm[piece.value] ?? {}).length > 0"></i>
                  <div class="placed-backg box" :style="{ backgroundImage: 'url(' + piece.image + ')' }"></div>
                </button>
              </div>
            </div>
          </div>
          <!-- Fin 1. Piezas a diseñar -->

          <!-- 2. Orientación -->
          <div class="card card-wrapper mb-3" :class="{ 'disabled': !currentPieceForm.piece }">
            <button class="btn btn-step" @click="toggleModelOptions()">
              <div class="col col-step-number"><span class="flex-center-xy">2</span></div>
              <div class="col col-text">
                <h6 class="box-title mb-1">Selecciona el estilo</h6>
                <p class="p-simple">Elige el grupo de productos perfecto para tu ocasión</p>
              </div>
              <div class="col col-check"><i class="fa-solid fa-circle-check" v-if="currentPieceForm.model"></i></div>

              <div class="col col-chevron">
                <i class="fa-solid fa-chevron-down text-muted icon" :class="{ 'active': expandedSections.model }"></i>
              </div>
            </button>

            <div class="card-body pt-0 box-models-options" v-if="expandedSections.model">
              <swiper class="swiper" :options="swiperModelOptions" v-if="expandedSections.model" ref="swiperModels">
                <swiper-slide v-for="(model, oInx) in modelOptions" :key="'oInx-'+oInx">
                  <div class="box-o-opt" :class="currentPieceForm.model === model.value ? 'active' : ''" @click="selectModel(model)">
                    <img :src="model.image">

                    <h5>{{ model.name }}</h5>
                  </div>
                </swiper-slide>
                
                <div class="swiper-pagination" slot="pagination"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
                <div class="swiper-button-next" slot="button-next"></div>
              </swiper>
            </div>
          </div>
          <!-- Fin 2. Orientación -->

          <!-- 3. Ocasión -->
          <div class="card card-wrapper mb-3" :class="{ 'disabled': !currentPieceForm.model }" v-if="showOccasionsOptions">
            <button class="btn btn-step" @click="expandedSections.occasion = !expandedSections.occasion">
              <div class="col col-step-number"><span class="flex-center-xy">3</span></div>
              <div class="col col-text">
                <h6 class="box-title mb-1">Selecciona la ocasión</h6>
                <p class="p-simple">Elige el tipo de evento para tu producto</p>
              </div>
              <div class="col col-check"><i class="fa-solid fa-circle-check" v-if="summaryInfo.occasion"></i></div>

              <div class="col col-chevron">
                <i class="fa-solid fa-chevron-down text-muted icon" :class="{ 'active': expandedSections.occasion }"></i>
              </div>
            </button>

            <div class="card-body pt-0 box-occasion-options" v-if="expandedSections.occasion">
              <div class="d-flex flex-nowrap overflow-auto pb-2" style="gap: 0.75rem;">
                <button
                  v-for="(occasion, ocInx) in occasionOptions"
                  :key="'ocInx-'+ocInx"
                  type="button"
                  class="btn btn-sm text-nowrap btn-occasion-option"
                  :class="{ 'active': currentPieceForm.occasion === occasion.id }"
                  @click="selectOccasion(occasion)"
                  :disabled="currentPieceForm.occasion === occasion.id"
                >
                  {{ occasion.name }}
                </button>
              </div>
            </div>
          </div>
          <!-- Fin 3. Ocasión -->

          <!-- 4. Bordado -->
          <div class="card card-wrapper mb-3" :class="{ 'disabled': !currentPieceForm.occasion }" v-if="showEmbroideriesOptions">
            <button class="btn btn-step" @click="expandedSections.embroidery = !expandedSections.embroidery">
              <div class="col col-step-number"><span class="flex-center-xy">4</span></div>
              <div class="col col-text">
                <h6 class="box-title mb-1">Bordado</h6>
                <p class="p-simple">Elige el diseño de bordado para tu ocasión</p>
              </div>
              <div class="col col-check"><i class="fa-solid fa-circle-check" v-if="summaryInfo.embroidery"></i></div>

              <div class="col col-chevron">
                <i class="fa-solid fa-chevron-down text-muted icon" :class="{ 'active': expandedSections.embroidery }"></i>
              </div>
            </button>

            <div class="card-body pt-0 box-embroidery-options" v-if="expandedSections.embroidery">
              <div class="row b-embroidery-container">
                <div class="col-4 col-embroidery-option" v-for="(embroidery, emInx) in embroideryOptions" :key="'emInx-'+emInx">
                  <button class="t-150 btn-embroidery-option" :class="{ 'active': currentPieceForm.embroidery === embroidery.id }" :disabled="currentPieceForm.embroidery === embroidery.id" @click="selectEmbroidery(embroidery)">
                    <div class="b-image" :style="{ backgroundImage: 'url(' + embroidery.image + ')' }">
                      <img src="public/images/pages/customizer/bordado-empty.png">
                    </div>
                    <div class="flex-center-xy b-name">{{ embroidery.name }}</div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- 5. Colores -->
          <div class="card card-wrapper mb-3" :class="{ 'disabled': (!currentPieceForm.embroidery && currentPieceForm.model != 'otu' && currentPieceForm.model != 'mtu') }">
            <button class="btn btn-step" @click="expandedSections.colors = !expandedSections.colors">
              <div class="col col-step-number">
                <span class="flex-center-xy" v-if="currentPieceForm.model != 'otu' && currentPieceForm.model != 'mtu'">5</span>
                <span class="flex-center-xy" v-else>3</span>
              </div>
              <div class="col col-text">
                <h6 class="box-title mb-1">Colores</h6>
                <p class="p-simple">Personaliza los colores de tu diseño</p>
              </div>
              <div class="col col-check"><i class="fa-solid fa-circle-check" v-if="allColorsSelected"></i></div>

              <div class="col col-chevron">
                <i class="fa-solid fa-chevron-down text-muted icon" :class="{ 'active': expandedSections.colors }"></i>
              </div>
            </button>

            <div class="card-body pt-0 box-colors-options" v-if="expandedSections.colors">
              <!-- Colores de fondo -->
              <div class="box-sec-colors pb-1">
                <button type="button" class="btn btn-light btn-sec-color mb-2" @click="expandedSections.backgroundColors = !expandedSections.backgroundColors; expandedSections.embroideryColors = false; expandedSections.ribbonColors = false;">
                  <div class="col col-text"><h6>Fondo</h6> <i class="b-selected-color" :style="{ backgroundColor: summaryInfo.backgroundColor.color_code }" v-if="summaryInfo.backgroundColor"></i></div>
                  <div class="col col-icon"><i class="fa-solid fa-chevron-down text-muted t-150 icon" :class="{ 'active': expandedSections.backgroundColors }"></i></div>
                </button>

                <div class="row box-colors-content" v-if="expandedSections.backgroundColors">
                  <div class="col-4 col-sm-4 col-md-3 col-lg-4 col-xl-3 col-color-option" v-for="(backgroundColor, bcInx) in backgroundColorsOptions" :key="'bcInx-'+bcInx">
                    <button class="btn btn-color-option" :class="{ 'active': currentPieceForm.backgroundColor === backgroundColor.id }" :disabled="currentPieceForm.backgroundColor === backgroundColor.id" @click="selectBackgroundColor(backgroundColor)">
                      <div class="color-option" :style="{ backgroundColor: backgroundColor.color_code }"></div>
                      <div class="color-name">{{ backgroundColor.name }}</div>
                    </button>                    
                  </div>
                </div>
              </div>
              
              <!-- Colores de cortinas -->
              <div class="box-sec-colors pb-1">
                <button type="button" class="btn btn-light btn-sec-color mb-2" @click="expandedSections.ribbonColors = !expandedSections.ribbonColors; expandedSections.backgroundColors = false; expandedSections.embroideryColors = false;">
                  <div class="col col-text">
                    <h6>{{ colorOptionName1 }}</h6>
                    <i class="b-selected-color" :style="{ backgroundColor: summaryInfo.ribbonColor.color_code }" v-if="summaryInfo.ribbonColor"></i>
                  </div>
                  <div class="col col-icon"><i class="fa-solid fa-chevron-down text-muted t-150 icon" :class="{ 'active': expandedSections.ribbonColors }"></i></div>
                </button>

                <div class="row box-colors-content" v-if="expandedSections.ribbonColors">
                  <div class="col-4 col-sm-4 col-md-3 col-lg-4 col-xl-3 col-color-option" v-for="(ribbonColor, rcInx) in ribbonColorsOptions" :key="'rcInx-'+rcInx">
                    <button class="btn btn-color-option" :class="{ 'active': currentPieceForm.ribbonColor === ribbonColor.style_id }" :disabled="currentPieceForm.ribbonColor === ribbonColor.style_id" @click="selectRibbonColor(ribbonColor)">
                      <div class="color-option" :class="{ 'bg-tull-glitter' : ribbonColor.type == 'Tull Glitter' }" :style="{ backgroundColor: ribbonColor.color_code }"></div>
                      <div class="color-name">
                        <h6 class="type" v-if="ribbonColor.type != null">
                          <span class="txt-type">{{ ribbonColor.type }}</span>
                        </h6>
                        <span class="color-name" :class="{ 'min-h' : ribbonColor.type != null }">{{ ribbonColor.name }}</span>
                      </div>
                    </button>                    
                  </div>
                </div>
              </div>

              <!-- Colores de bordado -->
              <div class="box-sec-colors pb-0 mb-0" v-if="showEmbroideryColors">
                <button type="button" class="btn btn-light btn-sec-color mb-2" @click="expandedSections.embroideryColors = !expandedSections.embroideryColors; expandedSections.backgroundColors = false; expandedSections.ribbonColors = false;">
                  <div class="col col-text"><h6>Bordado</h6> <i class="b-selected-color" :style="{ backgroundColor: summaryInfo.embroideryColor.color_code }" v-if="summaryInfo.embroideryColor"></i></div>
                  <div class="col col-icon"><i class="fa-solid fa-chevron-down text-muted t-150 icon" :class="{ 'active': expandedSections.embroideryColors }"></i></div>
                </button>

                <div class="row box-colors-content" v-if="expandedSections.embroideryColors">
                  <div class="col-4 col-sm-4 col-md-3 col-lg-4 col-xl-3 col-color-option" v-for="(embroideryColor, ecInx) in embroideryColorsOptions" :key="'ecInx-'+ecInx">
                    <button class="btn btn-color-option" :class="{ 'active': currentPieceForm.embroideryColor === embroideryColor.id }" :disabled="currentPieceForm.embroideryColor === embroideryColor.id" @click="selectEmbroideryColor(embroideryColor)">
                      <div class="color-option" :style="{ backgroundColor: embroideryColor.color_code }"></div>
                      <div class="color-name">{{ embroideryColor.name }}</div>
                    </button>                    
                  </div>
                </div>
              </div>

              <!-- Colores extra 1 -->
              <div class="box-sec-colors pb-0 mb-0" v-if="showExtraColors">
                <button type="button" class="btn btn-light btn-sec-color mb-2" @click="expandedSections.extraColors = !expandedSections.extraColors; expandedSections.backgroundColors = false; expandedSections.ribbonColors = false; expandedSections.embroideryColors = false;">
                  <div class="col col-text">
                    <h6>{{ colorOptionName4 }}</h6>
                    <i class="b-selected-color" :style="{ backgroundColor: summaryInfo.extraColor.color_code }" v-if="summaryInfo.extraColor"></i>
                  </div>
                  <div class="col col-icon"><i class="fa-solid fa-chevron-down text-muted t-150 icon" :class="{ 'active': expandedSections.extraColors }"></i></div>
                </button>

                <div class="row box-colors-content" v-if="expandedSections.extraColors">
                  <div class="col-4 col-sm-4 col-md-3 col-lg-4 col-xl-3 col-color-option" v-for="(extraColor, excInx) in extraColorsOptions" :key="'excInx-'+excInx">
                    <button class="btn btn-color-option" :class="{ 'active': currentPieceForm.extraColor === extraColor.id }" :disabled="currentPieceForm.extraColor === extraColor.id" @click="selectExtraColor(extraColor)">
                      <div class="color-option" :style="{ backgroundColor: extraColor.color_code }"></div>
                      <div class="color-name">{{ extraColor.name }}</div>
                    </button>                    
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 6. Accesorios -->
          <div class="card card-wrapper mb-3" :class="{ 'disabled': !currentPieceForm.embroideryColor }" v-if="showAccessoriesOptions">
            <button class="btn btn-step" @click="expandedSections.accessories = !expandedSections.accessories">
              <div class="col col-step-number"><span class="flex-center-xy">6</span></div>
              <div class="col col-text">
                <h6 class="box-title mb-1">Accesorios</h6>
                <p class="p-simple">Selecciona los accesorios para tu diseño</p>
              </div>
              <div class="col col-check"><i class="fa-solid fa-circle-check" v-if="summaryInfo.accessory"></i></div>

              <div class="col col-chevron">
                <i class="fa-solid fa-chevron-down text-muted icon" :class="{ 'active': expandedSections.accessories }"></i>
              </div>
            </button>

            <div class="card-body pt-0 box-accessories-options" v-if="expandedSections.accessories">
              <div class="row box-accessories-container">
                <div class="col-6 col-accessory-option" v-for="(accessory, aInx) in accessoriesOptions" :key="'aInx-'+aInx">
                  <button class="btn btn-accessory-option" :class="{ 'active': currentPieceForm.accessory === accessory.id }" :disabled="currentPieceForm.accessory === accessory.id" @click="selectAccessory(accessory)">{{ accessory.name }}</button>
                </div>
              </div>
            </div>            
          </div>

          <!-- 7. Texto -->
          <!-- <div class="card card-wrapper mb-3">
            <button class="btn btn-step" @click="expandedSections.text = !expandedSections.text">
              <div class="col col-step-number"><span class="flex-center-xy">7</span></div>
              <div class="col col-text">
                <h6 class="box-title mb-1">Personaliza el texto</h6>
                <p class="p-simple">Agrega tu texto personalizado</p>
              </div>
              <div class="col col-check"><i class="fa-solid fa-circle-check" v-if="summaryInfo.text"></i></div>

              <div class="col col-chevron">
                <i class="fa-solid fa-chevron-down text-muted icon" :class="{ 'active': expandedSections.text }"></i>
              </div>
            </button>

            <div class="card-body pt-0 box-text-options" v-if="expandedSections.text">
              <input
                v-model="currentPieceForm.text"
                type="text"
                maxlength="26"
                class="form-control custom-text-input"
                placeholder="Escribe tu texto..."
              >
            </div>
          </div> -->

          <!-- 8. Aplicar al set -->
          <!-- <div class="card card-wrapper mb-3 disabled">
            <button class="btn btn-step" @click="expandedSections.applySet = !expandedSections.applySet">
              <div class="col col-step-number">
                <span class="flex-center-xy" v-if="currentPieceForm.model != 'ev' && currentPieceForm.model != 'a3d' && currentPieceForm.model != 'aro' && currentPieceForm.model != 'agl' && currentPieceForm.model != 'cen'">7</span>
                <span class="flex-center-xy" v-else>6</span>
              </div>
              <div class="col col-text">
                <h6 class="box-title mb-1">Aplicar a todo el set</h6>
                <p class="p-simple">Aplicar este diseño a todas las piezas</p>
              </div>
              <div class="col col-check"><i class="fa-solid fa-circle-check" v-if="summaryInfo.applySet"></i></div>

              <div class="col col-chevron">
                <i class="fa-solid fa-chevron-down text-muted icon" :class="{ 'active': expandedSections.applySet }"></i>
              </div>
            </button>

            <div v-show="expandedSections.applySet" class="px-3 px-sm-4 pb-3 pb-sm-4">
              <button
                type="button"
                class="btn btn-block p-3 rounded border d-flex align-items-center justify-content-between border-2"
                :class="applyToSet ? 'border-primary bg-light' : 'border-secondary bg-white'"
                @click="applyToSet = !applyToSet"
              >
                <span class="small font-weight-medium text-dark">Aplicar este diseño a todo el set</span>
                <span
                  class="rounded border d-flex align-items-center justify-content-center"
                  :class="applyToSet ? 'bg-primary border-primary text-white' : 'bg-white border-secondary'"
                  style="width: 1.5rem; height: 1.5rem;"
                >
                  <i v-if="applyToSet" class="fa-solid fa-check small"></i>
                </span>
              </button>
            </div>
          </div> -->

          <!-- Sugerencias -->
          <!-- <div class="card border-2 mb-3">
            <div class="p-3 p-sm-4">
              <h3 class="h6 font-weight-semibold mb-3">Talvez también te interese...</h3>
              <div class="d-flex overflow-auto pb-2" style="gap: 1rem;">
                <div
                  v-for="(image, index) in PRODUCT_IMAGES"
                  :key="'prod-' + index"
                  class="flex-shrink-0 text-center"
                  style="width: 10rem;"
                >
                  <div class="rounded-lg border bg-light d-flex align-items-center justify-content-center overflow-hidden personalizador-related-thumb">
                    <img
                      :src="image || 'public/images/pages/customizer/placeholder.svg'"
                      :alt="'Producto ' + (index + 1)"
                      class="img-fluid p-2"
                      style="object-fit: contain;"
                    >
                  </div>
                  <p class="small text-muted mt-2 mb-0">Producto {{ index + 1 }}</p>
                </div>
              </div>
            </div>
          </div> -->
        </div>

        <!-- Vista previa -->
        <div class="col-lg-7 mb-4 col-preview">
          <div class="card p-3 p-sm-4 personalizador-preview-sticky">
            <div>
              <h6 class="box-title mb-1">Vista previa</h6>
              <p class="p-simple mb-3">Los cambios se reflejan en tiempo real</p>

              <div class="box-preview-container">
                <div class="box-top">
                  <!-- <a class="btn-zoom" @click.stop="isZoomModalOpen = true"><i class="fa-regular fa-magnifying-glass-plus"></i></a> -->
                </div>

                <div class="box-preview-images">
                  <LoadingComponent v-if="isMiniLoading"></LoadingComponent>
                  <div class="box-bg">
                    <img src="public/images/pages/customizer/bg-image.png" />
                  </div>

                  <div class="box-over b-base-image" v-if="currentPieceForm.occasion == null && currentPieceForm.piece == null">
                    <img src="public/images/pages/customizer/bg-empty.jpg" v-if="currentPieceForm.piece == null" />

                    <div class="flex-center-xy box-bg-text">
                      <h6 v-if="currentPieceForm.model == null">Seleccione un pieza a diseñar por favor</h6>
                    </div>
                  </div>
                  
                  <div class="box-over b-base-image" v-if="currentPieceForm.piece != null">
                    <img :src="toggleBaseImage()" @load="isMiniLoading = false" />

                    <div class="flex-center-xy box-bg-text">
                      <h6 v-if="currentPieceForm.piece != null && currentPieceForm.model == null">Seleccione un estilo por favor</h6>
                      <h6 v-if="(currentPieceForm.model != null && currentPieceForm.occasion == null) && (currentPieceForm.model != 'otu' && currentPieceForm.model != 'mtu')">Seleccione una ocasión por favor</h6>
                      <h6 v-if="currentPieceForm.occasion != null && currentPieceForm.embroidery == null">Seleccione un bordado para ver la vista previa</h6>
                    </div>
                  </div>

                  <div class="box-over b-bordado" :class="{ 
                      'b-libro' : step == 'libro' , 'b-caja' : step == 'caja' , 'b-muneca' : step == 'muneca' ,
                      'b-diagonal': currentPieceForm.model == 'd', 'b-horizontal': currentPieceForm.model == 'h', 'b-vertical': currentPieceForm.model == 'v', 'b-e-vertical': currentPieceForm.model == 'ev', 'b-a-3d': currentPieceForm.model == 'a3d', 'b-e-diagonal': currentPieceForm.model == 'ed', 'b-cen-diagonal': currentPieceForm.model == 'cen',  'b-glitter' : currentPieceForm.model == 'agl',
                      'b-everex': currentPieceForm.model == 'cee',
                      'b-cortina': currentPieceForm.model == 'mco'
                    }" v-if="currentPieceForm.embroideryColor">
                    <img :src="summaryInfo.embroideryColor.image" @load="isMiniLoading = false" />
                  </div>

                  <!-- Imagen del bordado temporal -->
                  <div class="box-over b-bordado" :class="{ 
                    'b-libro' : step == 'libro' , 'b-caja' : step == 'caja' , 'b-muneca' : step == 'muneca' ,
                    'b-diagonal': currentPieceForm.model == 'd', 'b-horizontal': currentPieceForm.model == 'h', 'b-vertical': currentPieceForm.model == 'v', 'b-e-vertical': currentPieceForm.model == 'ev', 'b-a-3d': currentPieceForm.model == 'a3d', 'b-e-diagonal': currentPieceForm.model == 'ed', 'b-cen-diagonal': currentPieceForm.model == 'cen',  'b-glitter' : currentPieceForm.model == 'agl', 'b-everex': currentPieceForm.model == 'cee', 
                    'b-everex': currentPieceForm.model == 'cee',  
                    'b-cortina': currentPieceForm.model == 'mco'
                    }" v-if="summaryInfo.embroideryTempo && summaryInfo.embroideryColor == null && summaryInfo.embroidery.previewImage != null">
                    <img :src="summaryInfo.embroidery.previewImage" @load="isMiniLoading = false" />
                  </div>
                  <!--  -->

                  <div class="box-over b-cortina" :class="{ 'bc-diagonal': currentPieceForm.model == 'd', 'bc-vertical': currentPieceForm.model == 'v', 'bc-horizontal': currentPieceForm.model == 'h' }" v-if="currentPieceForm.ribbonColor">
                    <!-- <img src="public/images/pages/customizer/z-vertical-2.png" /> -->
                    <img :src="summaryInfo.ribbonColor.image" @load="isMiniLoading = false" />
                  </div>

                  <div class="box-over b-extra" v-if="currentPieceForm.extraColor">
                    <!-- <img src="public/images/pages/customizer/z-vertical-2.png" /> -->
                    <img :src="summaryInfo.extraColor.image" @load="isMiniLoading = false" />
                  </div>
               
                  <div class="box-over b-accesorio" :class="{ 'ba-diagonal': currentPieceForm.model == 'd', 'ba-vertical': currentPieceForm.model == 'v', 'ba-horizontal': currentPieceForm.model == 'h', 'ba-e-diagonal': currentPieceForm.model == 'ed' }" v-if="currentPieceForm.accessory">
                    <img :src="summaryInfo.accessory.image" @load="isMiniLoading = false" />
                  </div>
                  
                  <!-- <div class="box-custom-text b-diagonal">
                    <h6>{{ currentPieceForm.text }} Tu texto aquí</h6>
                  </div>  -->
                </div>

                <div class="box-specs">
                  <h6 class="box-title mb-1">Especificaciones</h6>

                  <div class="row">
                    <div class="col-6 col-sm-4 col-label">Tamaño:</div>
                    <div class="col-6 col-sm-8 col-value">40cm × 40cm</div>
                    <div class="col-6 col-sm-4 col-label">Material:</div>
                    <div class="col-6 col-sm-8 col-value">Satín premium</div>
                    <div class="col-6 col-sm-4 col-label">Relleno:</div>
                    <div class="col-6 col-sm-8 col-value">Incluido</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- CTA inferior -->
      <div class="personalizador-sticky-cta bg-white py-3 sticky-bottom">
        <div class="container px-3">
          <hr class="mt-0 line-separator" />
          <a @click="nextStep()"
            to="/cart"
            class="btn btn-lg btn-block font-weight-bold text-white personalizador-cta-btn rounded-lg shadow"
            :class="{ disabled : isNextBtnDisabled }">
            Guardar pieza actual
          </a>
        </div>
      </div>
    </main>

    <!-- Modal recuperar -->
    <b-modal
      id="modal-recover"
      v-model="showRecoverModal"
      title=""
      centered
      hide-footer
      hide-header
    >
      <div class="text-center mb-3">
        <div class="rounded-circle bg-light-primary mx-auto mb-3 d-flex align-items-center justify-content-center personalizador-modal-icon">
          <i class="fa-solid fa-heart fa-2x text-primary"></i>
        </div>
        <h5 class="font-weight-bold">Recuperar diseño</h5>
        <p class="text-muted small mb-0">
          Ingresa el código que recibiste al guardar tu personalización
        </p>
      </div>
      <div class="form-group">
        <input
          type="text"
          class="form-control form-control-lg text-center font-monospace"
          placeholder="Ej: XV-123ABC-XYZ4"
          maxlength="20"
        >
        <p class="small text-danger text-center mt-2 mb-0">Error x</p>
      </div>
      
      <button
        type="button"
        class="btn btn-primary btn-block font-weight-bold mb-2"
      >
        Recuperar diseño
      </button>
      <button type="button" class="btn btn-light btn-block" @click="showRecoverModal = false">
        Cancelar
      </button>
    </b-modal>

    <!-- Modal guardar -->
    <b-modal
      id="modal-save"
      v-model="showSaveModal"
      title="Guardar y regresar después"
      centered
      hide-footer
    >
      <!-- <template>
        <div class="text-center mb-3">
          <div class="rounded-circle bg-light-primary mx-auto mb-3 d-flex align-items-center justify-content-center personalizador-modal-icon">
            <i class="fa-solid fa-heart fa-2x text-primary"></i>
          </div>
          <p class="text-muted small">
            Te generaremos un código único para que puedas recuperar tu personalización más tarde
          </p>
        </div>
        <button type="button" class="btn btn-primary btn-block font-weight-bold mb-2" @click="handleSaveCustomization">
          Generar código
        </button>
        <button type="button" class="btn btn-light btn-block" @click="showSaveModal = false">
          Cancelar
        </button>
      </template> -->

      <template>
        <div class="text-center mb-3">
          <div class="rounded-circle bg-success mx-auto mb-3 d-flex align-items-center justify-content-center personalizador-modal-icon">
            <i class="fa-solid fa-check fa-2x text-white"></i>
          </div>
          <p class="text-muted small mb-3">
            Guarda este código para recuperar tu diseño más tarde
          </p>
          <div class="border border-primary border-dashed rounded-lg p-3 mb-3 bg-light">
            <p class="small text-muted mb-1">Tu código</p>
            <div class="d-flex align-items-center justify-content-center flex-wrap" style="gap: 0.5rem;">
              <span class="h5 mb-0 text-primary font-weight-bold text-break">FFFF552522</span>
              <button type="button" class="btn btn-sm btn-outline-primary" title="Copiar código">
                <i class="fa-solid fa-check text-success"></i>
                <!-- <i class="fa-regular fa-copy"></i> -->
              </button>
            </div>
            <p class="small text-success mb-0 mt-2">Código copiado al portapapeles</p>
          </div>
        </div>
        <button
          type="button"
          class="btn btn-primary btn-block font-weight-bold"
          @click="showSaveModal = false"
        >
          Cerrar
        </button>
      </template>
    </b-modal>
    <!-- Fin modal Guardar -->

    <!-- Modal zoom -->
    <b-modal
      id="modal-zoom"
      modal-class="modal-customizer-zoom"
      v-model="isZoomModalOpen"
      size="xl"
      centered
      hide-footer
      title=""
      @hidden="isZoomModalOpen = false"
    >
      <div class="content">
        <div class="box-preview-images">
          <div class="box-bg">
            <img src="public/images/pages/customizer/bg-image.png" />
          </div>

          <div class="box-over b-base-image">
            <img src="public/images/pages/customizer/z-vertical-1.jpg" />
          </div>

          <div class="box-over b-bordado">
            <img src="public/images/pages/customizer/z-vertical-3.png" />
          </div>

          <div class="box-over b-cortina">
            <img src="public/images/pages/customizer/z-vertical-2.png" />
          </div>

          <div class="box-over b-accesorio">
            <img src="public/images/pages/customizer/z-vertical-4.png" />
          </div>

          <div class="box-custom-text">
            <h6>{{ currentPieceForm.text }}</h6>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Fin modal zoom -->
  </div>
</template>

<script>
import { sum } from 'lodash';
import LoadingComponent from '../shared/loading-component.vue';
export default {
  components: {
    LoadingComponent
  },

  data() {
    return {
      isLoading: true,
      isMiniLoading: false,
      isNextBtnDisabled: true,
      showOccasionsOptions: true,
      showEmbroideriesOptions: true,
      showEmbroideryColors: true,
      showExtraColors: false,
      showAccessoriesOptions: true,
      colorOptionName1: null,
      colorOptionName4: null,

      // Resumen de opciones seleccionadas
      summaryInfo: {
        piece: null,
        model: null,
        occasion: null,
        embroideryTempo: false,
        embroidery: null,
        ribbonColor: null,
        backgroundColor: null,
        embroideryColor: null,
        extraColor: null,
        accessory: null,
        text: null,
        // applySet: false,
      },

      // Secciones expandidas
      expandedSections: {
        piece: true,
        model: false,
        occasion: false,
        embroidery: false,
        colors: false,
        ribbonColors: false,
        backgroundColors: false,
        embroideryColors: false,
        extraColors: false,
        accessories: false,
        text: false,
        // applySet: false,
      },

      // Formulario actual de opciones seleccionadas
      currentPieceForm: {
        piece: null,
        model: null,
        occasion: null,
        embroidery: null,
        ribbonColor: null,
        backgroundColor: null,
        embroideryColor: null,
        extraColor: null,
        accessory: null,
        text: 'Tu texto aquí',
      },
      
      // Paso actual
      step: null,

      // Formulario final de opciones seleccionadas, por pieza (o paso)
      customizerForm: {
        libro: {},
        caja: {},
        oso: {},
        muneca: {},
      },

      // Imagenes base
      baseImages: {
        libro: 'public/images/pages/customizer/bg-book.jpg',
        caja: 'public/images/pages/customizer/bg-box.jpg',
        cajaEverex: 'public/images/pages/customizer/bg-box-everex.jpg',
        oso: 'public/images/pages/customizer/bg-bear.jpg',
        osoTull: 'public/images/pages/customizer/bg-bear-tull.jpg',
        muneca: 'public/images/pages/customizer/bg-doll.jpg',
        munecaTull: 'public/images/pages/customizer/bg-doll-tull.jpg',
      },

      // Paso 1. Piezas a diseñar
      pieceOptions: [
        { id: 1, name: 'Libro', value: 'libro', image: 'public/images/pages/customizer/libro.jpg' },
        { id: 2, name: 'Caja', value: 'caja', image: 'public/images/pages/customizer/caja.jpg' },
        { id: 3, name: 'Oso', value: 'oso', image: 'public/images/pages/customizer/oso.jpg' },
        { id: 4, name: 'Muñeca', value: 'muneca', image: 'public/images/pages/customizer/muneca.jpg' },
      ],

      // Paso 2. Opciones de orientación
      pieceModelOptions: {
        libro: [
          { name: 'Cortina Diagonal', value: 'd', image: 'public/images/pages/customizer/o-diagonal.jpg' },
          { name: 'Cortina Vertical', value: 'v', image: 'public/images/pages/customizer/o-vertical.jpg' },
          { name: 'Cortina Horizontal', value: 'h', image: 'public/images/pages/customizer/o-horizontal.jpg' },
          { name: 'Encaje Vertical', value: 'ev', image: 'public/images/pages/customizer/o-e-vertical.jpg' },
          { name: 'Encaje Diagonal', value: 'ed', image: 'public/images/pages/customizer/o-e-diagonal.jpg' },
          { name: 'Aplicaciones 3D', value: 'a3d', image: 'public/images/pages/customizer/o-a-3d.jpg' },
          { name: 'Aplicaciones Rosas', value: 'aro', image: 'public/images/pages/customizer/o-a-rosas.jpg' },
          { name: 'Aplicaciones Glitter', value: 'agl', image: 'public/images/pages/customizer/o-a-glitter.jpg' },
          { name: 'Modelo Centro', value: 'cen', image: 'public/images/pages/customizer/o-m-centro.jpg' },
        ],
        caja: [
          { name: 'Estilo Cortina', value: 'cor', image: 'public/images/pages/customizer/ca-cortina.jpg' },
          { name: 'Estilo Everex', value: 'cee', image: 'public/images/pages/customizer/ca-everex.jpg' },
          { name: 'Estilo Aplicaciones 3D', value: 'a3d', image: 'public/images/pages/customizer/ca-aplicaciones-3d.jpg' },
        ],
        oso: [
          { name: 'Oso Largo', value: 'ola', image: 'public/images/pages/customizer/os-largo.jpg' },
          { name: 'Oso Tull', value: 'otu', image: 'public/images/pages/customizer/os-tull.jpg' },
        ],
        muneca: [
          { name: 'Muñeca Cortina', value: 'mco', image: 'public/images/pages/customizer/mu-cortina.jpg' },
          { name: 'Muñeca Tull', value: 'mtu', image: 'public/images/pages/customizer/mu-tull.jpg' },
        ],
      },
      modelOptions: [],
      // == ==

      // Paso 3. Opciones de ocasión (bordado)
      occasionOptions: [
        { id: 1, name: 'XV Años', value: 'xv-anos' },
        { id: 2, name: 'Boda', value: 'boda' },
        { id: 3, name: 'Sweet 16', value: 'sweet-16' },
        { id: 4, name: '3 Años', value: '3-anos' },
      ],

      // Paso 4. Bordado
      embroideryOptions: [
        { id: 1, name: 'XV 003', image: 'public/images/pages/customizer/xv-design-003.jpg' },
        { id: 2, name: 'XV 004', image: 'public/images/pages/customizer/xv-design-004.jpg' },
        { id: 3, name: 'XV 008', image: 'public/images/pages/customizer/xv-design-008.jpg' },
      ],

      // Paso 5. Colores
      // 5.1 Colores de la cortina
      ribbonColorsOptions: [
        { id: 1, name: 'Blanco', color_code: '#ffffff' },
        { id: 2, name: 'Organza', color_code: '#f5f5f0' },
        { id: 3, name: 'Aqua', color_code: '#00ced1' },
        { id: 4, name: 'Baby blue', color_code: '#89cff0' },
        { id: 5, name: 'Rosa', color_code: '#ffc0cb' },
        { id: 6, name: 'Champagne', color_code: '#f7e7ce' },
        { id: 7, name: 'Oro', color_code: '#ffd700' },
        { id: 8, name: 'Plata', color_code: '#c0c0c0' },
      ],

      // 5.2 Colores del fondo
      backgroundColorsOptions: [
        { id: 1, name: 'Blanco', color_code: '#ffffff' },
        { id: 2, name: 'Aqua', color_code: '#00ced1' },
        { id: 3, name: 'Baby blue', color_code: '#89cff0' },
        { id: 4, name: 'Rosa', color_code: '#ffc0cb' },
        { id: 5, name: 'Champagne', color_code: '#f7e7ce' },
        { id: 6, name: 'Burgundy', color_code: '#800020' },
      ],

      // 5.3 Colores del bordado
      embroideryColorsOptions: [
        { id: 1, name: 'Plata', color_code: '#c0c0c0' },
        { id: 2, name: 'Oro', color_code: '#ffd700' },
        { id: 3, name: 'Rose gold', color_code: '#b76e79' },
        { id: 4, name: 'Blanco', color_code: '#ffffff' },
        { id: 5, name: 'Aqua', color_code: '#00ced1' },
      ],

      // 5.4 Colores extra
      extraColorsOptions: [
        { id: 1, name: 'Plata', color_code: '#c0c0c0' },
        { id: 2, name: 'Oro', color_code: '#ffd700' },
        { id: 3, name: 'Rose gold', color_code: '#b76e79' },
        { id: 4, name: 'Blanco', color_code: '#ffffff' },
        { id: 5, name: 'Aqua', color_code: '#00ced1' },
      ],

      // 6. Accesorios
      accessoriesOptions: [
        // { id: 1, name: 'Mariposa', image: '15-oro' },
        // { id: 2, name: 'Flor', image: '15-plata' },
        // { id: 3, name: 'Broche', value: '15-rosegold' },
        // { id: 4, name: 'Joya', image: 'corona-oro' },
      ],

      isZoomModalOpen: false,
      showSaveModal: false,
      showRecoverModal: false,
      applyToSet: false,

      // == Swiper options ==
      swiperModelOptions: {
        loop: false,

        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },

        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      },
      // == ==    
    }
  },

  methods: {
    nextStep() {
      if(!this.isNextBtnDisabled) {
        window.scrollTo(0, 0);
        this.isNextBtnDisabled = true;

        // Resetear variables
        setTimeout(() => {
          Object.keys(this.currentPieceForm).forEach(key => {
            if(key == 'text') {
              this.currentPieceForm[key] = 'Tu texto aquí';
            } else {
              this.currentPieceForm[key] = null;
            }
          });

          Object.keys(this.summaryInfo).forEach(key => {
            if(key == 'embroideryTempo') {
              this.summaryInfo[key] = false;
            }else {
              this.summaryInfo[key] = null;
            }
          });

          Object.keys(this.expandedSections).forEach(key => {
            if(key == 'piece') {
              this.expandedSections[key] = true;
            }else {
              this.expandedSections[key] = false;
            }
          });
        }, 200);
      } 
      else {
        alert('Error! No se puede avanzar al siguiente paso');
      }
    },

    resetSteps(currentStep) {
      // Resetear pasos posteriores
      if (currentStep <= 1) { // Pieza a diseñar
        this.currentPieceForm.model = null;
        this.summaryInfo.model = null;
        this.expandedSections.model = false;
      }
      if (currentStep <= 2) { // Estilo
        this.currentPieceForm.occasion = null;
        this.summaryInfo.occasion = null;
        this.expandedSections.occasion = false;
      }
      if(currentStep <= 3) { // Ocasión
        this.currentPieceForm.embroidery = null;
        this.summaryInfo.embroidery = null;
        this.expandedSections.embroidery = false;
        this.summaryInfo.embroideryTempo = false;
      }
      if(currentStep <= 4) { // Bordado
        this.currentPieceForm.ribbonColor = null;
        this.currentPieceForm.backgroundColor = null;
        this.currentPieceForm.embroideryColor = null;
        this.currentPieceForm.extraColor = null;
        this.summaryInfo.ribbonColor = null;
        this.summaryInfo.backgroundColor = null;
        this.summaryInfo.embroideryColor = null;
        this.summaryInfo.extraColor = null;
        this.expandedSections.colors = false;
      }
      if(currentStep <= 5) { // Colores varios
        this.currentPieceForm.accessory = null;
        this.summaryInfo.accessory = null;
        this.expandedSections.accessories = false;
      }

      // Desactivar el botón de "guardar pieza"
      this.isNextBtnDisabled = true;
    },

    /* disablePieceButton(pieceValue) {      
      if(this.currentPieceForm.piece == null && pieceValue == 'libro' && this.step == 'libro') {
        return false;
      } else {
        if(pieceValue == this.step) {
          return false;
        } else {
          return true;
        }
      }
    }, */

    selectPiece(piece) {    
      // Opciones a resetear
      this.showOccasionsOptions = true;
      this.showEmbroideriesOptions = true;
      this.showEmbroideryColors = true;
          
      // Si ya se seleccionaron las opciones de la pieza seleccionada, entonces cargar todos los datos de la categoria a la que pertenecen
      if(Object.keys(this.customizerForm[piece.value] ?? {}).length > 0) {
        // Resetear
        Object.keys(this.currentPieceForm).forEach(key => {
          this.currentPieceForm[key] = null;
        });

        // == Estilos ==  
        this.step = piece.value;
        this.currentPieceForm.piece = piece.value;
        this.summaryInfo.piece = piece;
        this.getBackgroundColorsOptions(this.currentPieceForm.piece);
        this.modelOptions = this.pieceModelOptions[this.currentPieceForm.piece];

        // == Modelos ==
        const currentModel = this.modelOptions.find(item => item.value === this.customizerForm[piece.value].model);
        
        // Simula paso 2 (Estilo)
        this.selectModel(currentModel, false);

        // == Datos de la pieza actual ==
        const filters = this.customizerForm[piece.value];

        axios.get(`/api/current-piece-options`, { params: filters })
          .then(response => {
            let currentPieceOptions = response.data;

            // Simula paso 3 (Ocasión)
            if(currentPieceOptions.currentOccasion) {
              this.selectOccasion(currentPieceOptions.currentOccasion, false);
            }

            // Simula paso 4 (Bordado)
            if(currentPieceOptions.currentEmbroidery) {
              this.selectEmbroidery(currentPieceOptions.currentEmbroidery, false);
            }

            // Simula paso 5.1 (Color de la cortina)
            this.selectRibbonColor(currentPieceOptions.currentRibbonColor, false);

            // Simula paso 5.2 (Color del fondo)
            this.selectBackgroundColor(currentPieceOptions.currentBackgroundColor, false);

            // Simula paso 5.3 (Color del bordado)
            if(currentPieceOptions.currentEmbroideryColor) {
              this.selectEmbroideryColor(currentPieceOptions.currentEmbroideryColor, false);
            }

            // Simula paso 5.4 (Color extra)
            if(currentPieceOptions.currentExtraColor) {
              this.selectExtraColor(currentPieceOptions.currentExtraColor, false);
            }

            // Simula paso 6 (Accesorio)
            if(currentPieceOptions.currentAccessory) {
              this.selectAccessory(currentPieceOptions.currentAccessory, false);
            }
            
            this.isLoading = false;
          })
        .catch(error => {
          console.error('Error al las opciones de la pieza actual:', error);
        })
        .finally(() => {
          // Desactivar el botón de "guardar pieza"
          this.isNextBtnDisabled = true;
        });
      }
      else { // Sino, resetear valores y traer datos del sig paso
        this.step = piece.value;
        this.currentPieceForm.piece = piece.value;
        this.summaryInfo.piece = piece;
        this.isMiniLoading = true;
        this.getBackgroundColorsOptions(this.currentPieceForm.piece);
        this.modelOptions = this.pieceModelOptions[this.currentPieceForm.piece];
        this.resetSteps(1);
      }      
    },

    toggleModelOptions() {
      this.expandedSections.model = !this.expandedSections.model;

      setTimeout(() => {
        if(this.currentPieceForm.model && this.expandedSections.model) {
          const modelIndex = this.modelOptions.findIndex(item => item.value === this.currentPieceForm.model); // Obtener el index para posicionarlo en el slider correcto
          this.$refs.swiperModels.$swiper.slideTo(modelIndex, 0);
        }
      }, 50);
    },

    toggleBaseImage() {
      let baseImage = this.baseImages[this.step];

      if(this.summaryInfo.backgroundColor) {
        baseImage = this.summaryInfo.backgroundColor.image;
      } else if(this.step == 'caja' && !this.summaryInfo.backgroundColor && this.currentPieceForm.model == 'cee') {
        baseImage = this.baseImages['cajaEverex'];
      }
      else if(this.step == 'oso' && !this.summaryInfo.backgroundColor && this.currentPieceForm.model == 'otu') {
        baseImage = this.baseImages['osoTull'];
      }
      else if(this.step == 'muneca' && !this.summaryInfo.backgroundColor && this.currentPieceForm.model == 'mtu') {
        baseImage = this.baseImages['munecaTull'];
      }

      return baseImage;
    },

    selectModel(model, resetStep = true) { 
      // Resetear variables necesarias
      this.currentPieceForm.model = model.value;
      this.summaryInfo.model = model;
      this.showOccasionsOptions = true;
      this.showEmbroideriesOptions = true;
      this.showEmbroideryColors = true;
      this.showAccessoriesOptions = false;
      this.showExtraColors = false;
      this.getRibbonColorsOptions();

      // Libros
      if(this.currentPieceForm.piece == 'libro') {
        // Mostrar u ocultar opciones de accesorios
        if(this.currentPieceForm.model != 'ev' && this.currentPieceForm.model != 'a3d' && this.currentPieceForm.model != 'aro' && this.currentPieceForm.model != 'agl' && this.currentPieceForm.model != 'cen') {
          this.showAccessoriesOptions = true;
        } else {
          this.showAccessoriesOptions = false;
        }

        // Dar nombre a la opción de color 1 en colores
        if(this.currentPieceForm.model == 'd' || this.currentPieceForm.model == 'v' || this.currentPieceForm.model == 'h' || this.currentPieceForm.model == 'cor') {
          this.colorOptionName1 = 'Cortina';
        }
        if(this.currentPieceForm.model == 'ev' || this.currentPieceForm.model == 'ed') {
          this.colorOptionName1 = 'Encaje';
        }
        if(this.currentPieceForm.model == 'a3d' || this.currentPieceForm.model == 'aro' || this.currentPieceForm.model == 'agl') {
          this.colorOptionName1 = 'Aplicación';
        }
        if(this.currentPieceForm.model == 'cen') {
          this.colorOptionName1 = 'Pasamanería';
        }
      }
      
      // Cajas
      if(this.currentPieceForm.piece == 'caja') {
        // Traer las opciones extras (4ta opción)
        this.showExtraColors = true;
        this.getExtraColorsOptions();

        // Dar nombre a la opción de color 1 en colores
        if(this.currentPieceForm.model == 'cor' || this.currentPieceForm.model == 'cee') {
          this.colorOptionName1 = 'Cortina';
        }
        if(this.currentPieceForm.model == 'a3d') {
          this.colorOptionName1 = 'Pasamanería';
        }

        // Dar nombre a la opción de color 4 en colores
        if(this.currentPieceForm.model == 'cor') {
          this.colorOptionName4 = 'Pasamanería';
        }
        if(this.currentPieceForm.model == 'cee') {
          this.colorOptionName4 = 'Malla flor';
        }
        if(this.currentPieceForm.model == 'a3d') {
          this.colorOptionName4 = 'Aplicación';
        }
      }

      // Osos
      if(this.currentPieceForm.piece == 'oso') {
        this.showExtraColors = true;
        this.getExtraColorsOptions();

        // Dar nombre a la opción de color 1 en colores
        if(this.currentPieceForm.model == 'ola' || this.currentPieceForm.model == 'otu') {
          this.colorOptionName1 = 'Cortina';
          this.colorOptionName4 = 'Encaje';
        }

        // Cuando sea el oso tipo "tull", ocultar pasos 3 (Ocasión) y 4 (Bordado). Esos pasos no se necesitan. Además, habilitar paso 5 (Colores)
        if(this.currentPieceForm.model == 'otu') {
          this.showOccasionsOptions = false;
          this.showEmbroideriesOptions = false;
          this.showEmbroideryColors = false;
        }        
      }

      // Muñecas
      if(this.currentPieceForm.piece == 'muneca') {
        this.showExtraColors = false;
        this.colorOptionName1 = 'Cortina';

        // Cuando sea la muñeca tipo "tull", ocultar pasos 3 (Ocasión) y 4 (Bordado). Esos pasos no se necesitan. Además, habilitar paso 5 (Colores)
        if(this.currentPieceForm.model == 'mtu') {
          this.showOccasionsOptions = false;
          this.showEmbroideriesOptions = false;
          this.showEmbroideryColors = false;
        } 
      }

      if(resetStep == true) {
        this.resetSteps(2);
      }
    },

    selectOccasion(occasion, resetStep = true) {
      this.currentPieceForm.occasion = occasion.id;
      this.summaryInfo.occasion = occasion;
      this.getEmbroideryOptions();

      if(resetStep == true) {
        this.resetSteps(3);
      }
    },

    selectEmbroidery(embroidery, resetStep = true) {
      this.currentPieceForm.embroidery = embroidery.id;
      this.summaryInfo.embroidery = embroidery;
      this.summaryInfo.embroideryTempo = true;
      this.getEmbroideryColorsOptions();

      if(resetStep == true) {
        this.resetSteps(4);
      }
    },

    selectRibbonColor(ribbonColor, resetStep = true) {
      this.currentPieceForm.ribbonColor = ribbonColor.style_id;
      this.summaryInfo.ribbonColor = ribbonColor;
      this.isMiniLoading = true;

      if(resetStep == true) {
        this.resetSteps(5);
      }

      this.saveCurrentPiece();
    },

    selectBackgroundColor(backgroundColor, resetStep = true) {
      this.currentPieceForm.backgroundColor = backgroundColor.id;
      this.summaryInfo.backgroundColor = backgroundColor;
      this.isMiniLoading = true;
      
      if(resetStep == true) {
        this.resetSteps(5);
      }

      this.saveCurrentPiece();
    },

    selectEmbroideryColor(embroideryColor, resetStep = true) {
      this.currentPieceForm.embroideryColor = embroideryColor.id;
      this.summaryInfo.embroideryColor = embroideryColor;
      this.isMiniLoading = true;
      
      if(resetStep == true) {
        this.resetSteps(5);
      }

      this.saveCurrentPiece();
    },

    selectExtraColor(extraColor, resetStep = true) {
      this.currentPieceForm.extraColor = extraColor.id;
      this.summaryInfo.extraColor = extraColor;
      this.isMiniLoading = true;
      
      if(resetStep == true) {
        this.resetSteps(5);
      }

      this.saveCurrentPiece();
    },

    selectAccessory(accessory, resetStep = true) {
      this.currentPieceForm.accessory = accessory.id;
      this.summaryInfo.accessory = accessory;
      this.isMiniLoading = true;
      
      if(resetStep == true) {
        this.resetSteps(6);
      }

      this.saveCurrentPiece(); 
    },

    // Guardar pieza actual para despues elegir otra (libro, caja, oso, etc) y activa el boton de resetear/proceder al sig paso
    saveCurrentPiece() {
      let savePiece = false;

      if(this.showAccessoriesOptions) { // Verificar si un accesorio fue seleccionado, antes de guardar
        if(this.currentPieceForm.accessory != null) {
          savePiece = true;
        }
      }
      else { // Verificar si estan todos los colores seleccionados, antes de guardar
        if(this.currentPieceForm.ribbonColor != null && this.currentPieceForm.backgroundColor != null) {
          savePiece = true;

          // Verificar si el modelo seleccionado, tiene la opción de color de bordado
          if(this.showEmbroideryColors && this.currentPieceForm.embroideryColor == null) {
            savePiece = false;
          }

          // Verificar si el modelo seleccionado, tiene la opción de color extra, y si sí, entonces debe estar seleccionado
          if(this.showExtraColors && this.currentPieceForm.extraColor == null) { 
            savePiece = false;
          }
        }
      }

      // Si todos los colores y accesorios (de haberlos) fueron seleccionados, entonces guardar la pieza actual
      if(savePiece == true) {
        if(this.currentPieceForm.piece == 'libro') {
          this.customizerForm.libro = { ...this.currentPieceForm };
          this.isNextBtnDisabled = false;
        }
        if(this.currentPieceForm.piece == 'caja') {
          this.customizerForm.caja = { ...this.currentPieceForm };
          this.isNextBtnDisabled = false;
        }
        if(this.currentPieceForm.piece == 'oso') {
          this.customizerForm.oso = { ...this.currentPieceForm };
          this.isNextBtnDisabled = false;
        }
        if(this.currentPieceForm.piece == 'muneca') {
          this.customizerForm.muneca = { ...this.currentPieceForm };
          this.isNextBtnDisabled = false;
        }
      }
    },

    shareOnWhatsApp() {
      // const estiloNombre = STYLE_GROUPS.find((s) => s.id === this.options.estilo)
      // const message =
      //   `¡Mira mi cojín personalizado! \n\n` +
      //   `Estilo: ${estiloNombre ? estiloNombre.name : ''}\n` +
      //   `Nombre: ${this.options.nombre || 'Sin nombre'}\n` +
      //   `Fecha: ${this.options.fecha || 'Sin fecha'}\n` +
      //   `Texto: ${this.options.texto || 'Sin texto'}\n\n` +
      //   `¡Personaliza el tuyo en XV Shopping!`
      // const whatsappUrl = `https://wa.me/?text=${encodeURIComponent(message)}`
      // window.open(whatsappUrl, '_blank')
    },

    // Obtener las ocasiones
    getOccasionsOptions() {
      this.isLoading = true;
      axios.get('/api/occasions-options')
        .then(response => {
          this.occasionOptions = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error al obtener las ocasiones:', error);
        });
    },

    // Obtener los bordados
    getEmbroideryOptions() {
      this.isLoading = true;
      const pieceType = this.currentPieceForm.piece;
      const occasionId = this.currentPieceForm.occasion;

      axios.get(`/api/embroideries-options/${pieceType}/${occasionId}`)
        .then(response => {
          this.embroideryOptions = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error al obtener los bordados:', error);
        });
    },

    // Obtener los colores de fondo
    getBackgroundColorsOptions(pieceType) {
      this.isLoading = true;
      const modelId = this.currentPieceForm.model;

      axios.get(`/api/background-colors-options/${pieceType}/${modelId}`)
        .then(response => {
          this.backgroundColorsOptions = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error al obtener los colores de fondo:', error);
        });
    },

    // Obtener las cortinas
    getRibbonColorsOptions() {
      this.isLoading = true;
      const pieceType = this.currentPieceForm.piece;
      const modelId = this.currentPieceForm.model;

      // Volver a traer los colores de fondo para ciertos modelos, dependiendo del modelo/style_type seleccionado
      if(this.currentPieceForm.piece == 'caja' || this.currentPieceForm.piece == 'oso' || this.currentPieceForm.piece == 'muneca') {
        this.getBackgroundColorsOptions(pieceType);
      }

      axios.get(`/api/ribbon-colors-options/${pieceType}/${modelId}`)
        .then(response => {
          this.ribbonColorsOptions = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error al obtener las cortinas:', error);
        });
    },

    // Obtener los colores del bordado
    getEmbroideryColorsOptions() {
      this.isLoading = true;
      const pieceType = this.currentPieceForm.piece;
      const embroideryId = this.currentPieceForm.embroidery;
      
      axios.get(`/api/embroidery-colors-options/${pieceType}/${embroideryId}`)
        .then(response => {
          this.embroideryColorsOptions = response.data;
          this.isLoading = false;
        });
    },

    getExtraColorsOptions() {
      this.isLoading = true;
      const pieceType = this.currentPieceForm.piece;
      const modelType = this.currentPieceForm.model;

      axios.get(`/api/extra-colors-options/${pieceType}/${modelType}`)
        .then(response => {
          this.extraColorsOptions = response.data;
          this.isLoading = false;
        })
        .catch(error => {
          console.error('Error al obtener los colores extra:', error);
        });
    },

    // Obtener los accesorios
    getAccessoriesOptions() {
      this.isLoading = true;
      axios.get('/api/accessories-options')
        .then(response => {
          this.accessoriesOptions = response.data;
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.getOccasionsOptions();
    this.getAccessoriesOptions();
  },

  computed: {
    allColorsSelected() {
      if(this.currentPieceForm.piece == 'oso' && this.currentPieceForm.model == 'otu') {
        return this.currentPieceForm.ribbonColor && this.currentPieceForm.backgroundColor && this.currentPieceForm.extraColor;
      }
      else if(this.currentPieceForm.piece == 'muneca' && this.currentPieceForm.model == 'mco') {
        return this.currentPieceForm.ribbonColor && this.currentPieceForm.backgroundColor && this.currentPieceForm.embroideryColor;
      }
      else if(this.currentPieceForm.piece == 'muneca' && this.currentPieceForm.model == 'mtu') {
        return this.currentPieceForm.backgroundColor && this.currentPieceForm.ribbonColor;
      }
      else {
        return this.currentPieceForm.ribbonColor && this.currentPieceForm.backgroundColor && this.currentPieceForm.embroideryColor && this.currentPieceForm.extraColor;
      }
    }
  },
}
</script>